import axios from "axios";
import { baseUrl } from "../../config/baseUrl";

const API_MAP = {
  library: `${baseUrl}/library`,
  mentor: `${baseUrl}/mentors`,
  ebook: `${baseUrl}/ebook`,
};

export const fetchCategoryOptions = async (category, token) => {
  if (!API_MAP[category]) {
    return [];
  }

  const response = await axios.get(API_MAP[category], {
    headers: {
      Authorization: token,
    },
  });

  return (
    response.data?.data ||
    response.data?.combinedData ||
    (Array.isArray(response.data) ? response.data : [])
  );
};

export const fetchPackages = async (token) => {
  const response = await axios.get(`${baseUrl}/admin/package`, {
    headers: {
      Authorization: token,
    },
  });

  return response.data?.data || [];
};

export const getCategoryLabel = (category) => {
  switch (category) {
    case "library":
      return "Library";
    case "mentor":
      return "Mentor";
    case "ebook":
      return "Ebook";
    case "exam":
      return "Package";
    case "all":
      return "All";
    default:
      return category || "-";
  }
};

export const getTargetLabel = (item, category) => {
  if (!item) {
    return "";
  }

  switch (category) {
    case "library":
      return item.libraryName || item.name || item._id;
    case "mentor":
      return item.mentorName || item.name || item._id;
    case "ebook":
      return item.bookTitle || item.title || item._id;
    case "exam":
      return item.exam_title || item.examTitle || item.title || item._id;
    default:
      return item.name || item.title || item._id;
  }
};

export const getPackageLabel = (pkg) =>
  `${pkg.title || "Untitled Package"}${pkg.packageCode ? ` (${pkg.packageCode})` : ""}`;
